import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import actions from '../../../../../store/actions'
import s from './style.module.scss'
import { Link } from 'react-router-dom'

class Schoose extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      // 初始state
      index: 0,
      opacity: 1,
      showTVersionShops: false,
      showMVersionShops: false,
    }
    this._handleScroll = this.handleScroll.bind(this)
  }
  componentDidMount() {
    window.addEventListener('scroll', this._handleScroll)
    window.addEventListener('goodLinksLoaded', this.handleGoodLinksLoaded);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this._handleScroll)
    window.removeEventListener('goodLinksLoaded', this.handleGoodLinksLoaded);
  }
  handleScroll() {
    const clientHeight = document.documentElement.clientHeight
    const textRect = this.refs.goose_add_part.getBoundingClientRect()
    if (clientHeight - 200 > textRect.top && this.refs.goose_add_part) {
      setTimeout(() => {
        // this.refs.top_text.style.opacity = 1;
        // this.refs.top_text.style.top = '100px';
      }, 500)
    }
  }
  handleGoodLinksLoaded = () => {
    this.forceUpdate();
  }
  
  handleTVersionClick = () => {
    if (!this.state.showTVersionShops) {
      this.setState({ showTVersionShops: true, showMVersionShops: false });
    }
  }
  
  handleMVersionClick = () => {
    if (!this.state.showMVersionShops) {
      this.setState({ showMVersionShops: true, showTVersionShops: false });
    }
  }
  
  handleMouseLeave = () => {
    this.setState({ showTVersionShops: false, showMVersionShops: false });
  }
  
  render() {
    const { locale } = this.props
    const { showTVersionShops, showMVersionShops } = this.state
    const ifUs = locale.indexOf('US') > -1
    const ifTwOrUs = locale.indexOf('US') > -1 || locale.indexOf('TW') > -1


    const goodLinksOrigin = localStorage.getItem('goodLinks')
    const goodsLink = goodLinksOrigin ? JSON.parse(goodLinksOrigin) : []
    const Malls = goodsLink['motion-light-sensor']?.shops || []
    const getJumpLink = Malls?.filter(item => item.tag) || []

    const tJumpLink = getJumpLink.filter(item => item.name_key.startsWith('t_'));
    const mJumpLink = getJumpLink.filter(item => item.name_key.startsWith('m_'));
    const tVersionShops = Malls.filter(item => item.name_key.startsWith('t_'));
    const mVersionShops = Malls.filter(item => item.name_key.startsWith('m_'));
    
    const hasTJumpLink = tJumpLink && tJumpLink.length > 0;
    const hasMJumpLink = mJumpLink && mJumpLink.length > 0;
    
    return (
      <div className={s.goose_choose} ref="goose_add_part">
        <div className={s.table}>
          <div className={s.row}>
            <div className={s.column1} style={{ height: 360 }}></div>
            <div
              className={s.column2}
              style={{ height: 360, justifyContent: 'space-around' }}
            >
              <div className={s.title}>
                <FormattedMessage id="t_version" />
              </div>
              <i className={s.icon_t}></i>
              <div className={s.buy}>
                <div className={s.shopBox} onMouseLeave={this.handleMouseLeave}>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}>
                    <div 
                      className={`${s.shopArrow} ${!goodLinksOrigin ? s.disabled : ''}`}
                      onClick={hasTJumpLink ? null : this.handleTVersionClick}
                    >
                      {goodLinksOrigin ? (
                        hasTJumpLink ? (
                          <a
                            href={tJumpLink[0].link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FormattedMessage id="buy" />
                          </a>
                        ) : (
                          <a href="javascript:void(0)">
                            <FormattedMessage id="buy" />
                          </a>
                        )
                      ) : (
                        <a href="javascript:void(0)">
                          <FormattedMessage id="buy" />
                        </a>
                      )}
                    </div>
                    {tVersionShops.length > 0 && !hasTJumpLink && (
                      <div className={s.arrowBox}>
                        <div className={s.arrow} onClick={this.handleTVersionClick}></div>
                        <div
                          style={{
                            position: 'absolute',
                            height: 20,
                            width: 32,
                            top: 20,
                          }}
                        ></div>

                        <div 
                          className={s.wrapMall} 
                          name="wrapMall"
                          style={showTVersionShops ? { display: 'block' } : {}}
                        >
                          <div className={s.mallBox}>
                            {tVersionShops.map((item, index) => {
                              return (
                                <a
                                  className={s.mallItem}
                                  key={item.name_key}
                                  href={item.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <FormattedMessage id={item.name_key} />
                                </a>
                              )
                            })}
                          </div>
                          <div style={{ height: 16 }}></div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <i className={s.icon_homekit}></i>
            </div>
            <div
              className={s.column2}
              style={{ height: 360, justifyContent: 'space-around' }}
            >
              <div className={s.title}>
                <FormattedMessage id="m_version" />
              </div>
              <i className={s.icon_hm}></i>
              <div className={s.buy}>
                <div className={s.shopBox} onMouseLeave={this.handleMouseLeave}>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}>
                    <div 
                      className={`${s.shopArrow} ${!goodLinksOrigin ? s.disabled : ''}`}
                      onClick={hasMJumpLink ? null : this.handleMVersionClick}
                    >
                      {goodLinksOrigin ? (
                        hasMJumpLink ? (
                          <a
                            href={mJumpLink[0].link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FormattedMessage id="buy" />
                          </a>
                        ) : (
                          <a href="javascript:void(0)">
                            <FormattedMessage id="buy" />
                          </a>
                        )
                      ) : (
                        <a href="javascript:void(0)">
                          <FormattedMessage id="buy" />
                        </a>
                      )}
                    </div>
                    {mVersionShops.length > 0 && !hasMJumpLink && (
                      <div className={s.arrowBox}>
                        <div className={s.arrow} onClick={this.handleMVersionClick}></div>
                        <div
                          style={{
                            position: 'absolute',
                            height: 20,
                            width: 32,
                            top: 20,
                          }}
                        ></div>

                        <div 
                          className={s.wrapMall} 
                          name="wrapMall"
                          style={showMVersionShops ? { display: 'block' } : {}}
                        >
                          <div className={s.mallBox}>
                            {mVersionShops.map((item, index) => {
                              return (
                                <a
                                  className={s.mallItem}
                                  key={item.name_key}
                                  href={item.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <FormattedMessage id={item.name_key} />
                                </a>
                              )
                            })}
                          </div>
                          <div style={{ height: 16 }}></div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <i
                className={locale.indexOf('US') > -1 ? s.icon_mi_en : s.icon_mi}
              ></i>
            </div>
          </div>

          <div className={s.row}>
            <div className={s.column1}>
              <FormattedMessage id="wireless" />
            </div>
            <div className={s.column2}>
              <FormattedMessage id="thread" />
            </div>
            <div className={s.column2}>
              <FormattedMessage id="bluetooth" />
            </div>
          </div>

          <div className={s.row}>
            <div className={s.column1}>
              <FormattedMessage id="support_operation" />
            </div>
            <div className={s.column2}>
              <FormattedMessage id="iOS" />
            </div>
            <div className={s.column2}>
              <FormattedMessage id="iOS_Android" />
            </div>
          </div>

          <div className={s.row}>
            <div className={s.column1} style={{ height: 120 }}>
              <FormattedMessage id="support_app" />
            </div>
            <div
              className={s.column2}
              style={{ flexDirection: 'row', justifyContent: 'center' }}
            >
              <div className={s.home}>
                <i className={s.icon_home}></i>
                <FormattedMessage id="family" />
              </div>
              <div className={s.plus}>
                <i className={s.icon_plus}></i>
                <FormattedMessage id="plus_plus" />
              </div>
            </div>
            <div className={s.column4}>
              <i className={s.icon_mihome}></i>
              <FormattedMessage id="mi_home" />
            </div>
            <div className={s.column4}>
              <i className={s.icon_plus}></i>
              <FormattedMessage id="plus_plus" />
            </div>
          </div>
          <div className={s.row} style={{ height: ifUs ? 256 : 184 }}>
            <div className={s.column1}>
              <FormattedMessage id="remote_access" values={{ br: <br /> }} />
            </div>
            <div
              className={s.column2}
              style={{
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                paddingLeft: ifUs ? 20 : 30,
                lineHeight: '24px',
              }}
            >
              <FormattedMessage id="need_homepod_tv" values={{ br: <br /> }} />
              <br />
              <FormattedMessage id="need_thread" values={{ br: '' }} />
            </div>
            <div
              className={s.column4}
              style={{
                paddingLeft: ifUs ? 20 : 20,
                paddingRight: ifUs ? 20 : 20,
                display: 'inline',
              }}
            >
              <FormattedMessage
                id="need_mi_qingping_gateway"
                values={{ br: <br /> }}
              />
              <Link
                target="_blank"
                to="/bluetooth-gateway"
                style={{ color: '#000' }}
              >
                <FormattedMessage id="sparrow" />
              </Link>
              <FormattedMessage id="end" />
            </div>
            <div
              className={s.column4}
              style={{
                paddingLeft: ifUs ? 20 : 20,
                paddingRight: ifUs ? 20 : 20,
                display: 'inline',
              }}
            >
              <FormattedMessage
                id="need_qingping_gateway"
                values={{ br: <br /> }}
              />
              <Link
                target="_blank"
                to="/bluetooth-gateway"
                style={{ color: '#000' }}
              >
                <FormattedMessage id="sparrow" />
              </Link>
              <FormattedMessage id="end" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  locale: state.language,
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  changeLanguage: (val) => dispatch(actions.changeLanguage(val)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Schoose)
